import { createFileRoute } from '@tanstack/react-router'

/**
 * `/tasks` with no Task named. The list lives in the parent route, so this renders nothing: the page is
 * the same page whether or not a Task's drawer is open, and following a notification link must not
 * rebuild it.
 */
export const Route = createFileRoute('/_app/tasks/')({
  component: () => null,
})
